import React from 'react'
import GModal from 'tennders-market/common/components/element/GModal'
import DOMPurify from 'dompurify'

const RouteInstructions = ({ t, route, ...rest }) => (
  <GModal {...rest}>

    <div className="tennders-modal-body w-100">
      <div className="tennders-modal-body">

        <h2 className="bold">{t('transaction:instructions')}</h2>
        <p className="bold">{`${route.label} ${route.date?.f}`}</p>
        <p className="mb-0" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(route.instructions?.replace(/\n/g, '<br/>')) }} />

      </div>
    </div>
  </GModal>
)

export default RouteInstructions
